import React from "react";
import styled from "styled-components";
import homeImage from "../assets/giraffes.jpg";
//import homeImage from "../assets/hero.png";
export default function Hero() {
	return (
		<Section id="hero">
			<div className="background">
				<img src={homeImage} alt="" />
			</div>

			<div className="content">
				<div className="title">
					{/* <div className="titleRow">
            <div className="titleText"><h1>VISIT</h1></div>
            <div className="titleDots"> </div>
            <div className="titleText"><h1>EXPLORE</h1></div>
            <div className="titleDots"> </div>
            <div className="titleText"><h1>EXPERIENCE</h1></div>
          </div> */}

					<h1>VISIT • EXPLORE • EXPERIENCE</h1>

					<div class="clear"></div>

					<p>
						Create Breath Taking Memories as you tour the beautiful pearl of
						africa!
					</p>
				</div>
				{/* <div className="search">
          <div className="container">
            <label htmlFor="">Where you want to go</label>
            <input type="text" placeholder="Search Your location" />
          </div>
          <div className="container">
            <label htmlFor="">Check-in</label>
            <input type="date" />
          </div>
          <div className="container">
            <label htmlFor="">Check-out</label>
            <input type="date" />
          </div>
          <button>Explore Now</button>
        </div> */}
				<button className="cta">Explore Now</button>
			</div>
		</Section>
	);
}

const Section = styled.section`
	position: relative;
	margin-top: 2rem;
	width: 100%;
	height: 100%;

	.background {
		height: 100%;
		img {
			width: 100%;
			height: 90vh;
			object-fit: cover;
			filter: brightness(60%);
			border-radius: 0.5rem;
		}
	}
	.content {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		z-index: 3;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 1rem;
		.title {
			color: white;
			display: flex;
			flex-direction: column;
			align-items: center;
			h1 {
				font-size: 3rem;
				letter-spacing: 0.2rem;
			}
			p {
				text-align: center;
				padding: 0 30vw;
				margin-top: 0.5rem;
				font-size: 1.2rem;
				text-transform: capitalize;
			}
		}
		.titleRow {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			width: 60%;
		}
		.titleDots {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 15px;
			width: 15px;
			background-color: white;
			border-radius: 50px;
			margin: auto;
		}
		.cta {
			padding: 1rem;
			cursor: pointer;
			border-radius: 0.3rem;
			border: none;
			color: white;
			//background-color: #4361ee;
			background-color: #39a0e6;
			font-size: 1.1rem;
			text-transform: uppercase;
			transition: 0.3s ease-in-out;
			&:hover {
				//background-color: #023e8a;
				background-color: #276d9b;
			}
		}
		.search {
			display: flex;
			background-color: #ffffffce;
			padding: 0.5rem;
			border-radius: 0.5rem;
			.container {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				padding: 0 1.5rem;
				label {
					font-size: 1.1rem;
					color: #03045e;
				}
				input {
					background-color: transparent;
					border: none;
					text-align: center;
					color: black;
					&[type="date"] {
						padding-left: 3rem;
					}

					&::placeholder {
						color: black;
					}
					&:focus {
						outline: none;
					}
				}
			}
			button {
				padding: 1rem;
				cursor: pointer;
				border-radius: 0.3rem;
				border: none;
				color: white;
				background-color: #4361ee;
				font-size: 1.1rem;
				text-transform: uppercase;
				transition: 0.3s ease-in-out;
				&:hover {
					background-color: #023e8a;
				}
			}
		}
	}

	@media screen and (min-width: 280px) and (max-width: 980px) {
		height: 25rem;
		.background {
			background-color: palegreen;
			img {
				height: 100%;
			}
		}
		.content {
			.title {
				h1 {
					font-size: 0.8rem;
					font-weight: 900;
				}
				p {
					font-size: 0.8rem;
					padding: 1vw;
				}
			}
			.titleRow {
				display: flex;
				flex-direction: column;
			}
			.titleDots {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 8px;
				width: 8px;
				background-color: white;
				border-radius: 50px;
				margin: auto;
			}
			.search {
				flex-direction: column;
				padding: 0.8rem;
				gap: 0.8rem;
				/* padding: 0; */
				.container {
					padding: 0 0.8rem;
					input[type="date"] {
						padding-left: 1rem;
					}
				}
				button {
					padding: 1rem;
					font-size: 1rem;
				}
				/* display: none; */
			}
		}
	}
`;
